import { useEffect } from 'react';

const SITE_TITLE = 'FUTURE WORLD';

export const buildDocumentTitle = (pageTitle?: string | null) => {
  const normalizedTitle = (pageTitle ?? '').trim();
  return normalizedTitle ? `${normalizedTitle} | ${SITE_TITLE}` : SITE_TITLE;
};

const useDocumentTitle = (pageTitle?: string | null) => {
  useEffect(() => {
    if (typeof document === 'undefined') {
      return;
    }

    document.title = buildDocumentTitle(pageTitle);
  }, [pageTitle]);
};

export default useDocumentTitle;
